import { useTheme } from '../components/styles/styles';

export const ExpandIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33325 6.36659C8.24436 6.2777 8.13325 6.23325 7.99992 6.23325C7.86659 6.23325 7.75547 6.2777 7.66658 6.36659L5.58325 8.44992C5.51659 8.51659 5.48325 8.6027 5.48325 8.70825C5.48325 8.81381 5.52214 8.89992 5.59992 8.96659C5.6777 9.04436 5.76659 9.08325 5.86658 9.08325C5.96659 9.08325 6.05547 9.04436 6.13325 8.96659L7.99992 7.09992L9.88325 8.98325C9.96103 9.06103 10.0499 9.09992 10.1499 9.09992C10.2499 9.09992 10.3388 9.06103 10.4166 8.98325C10.4833 8.90547 10.5166 8.81381 10.5166 8.70825C10.5166 8.6027 10.4833 8.51659 10.4166 8.44992L8.33325 6.36659ZM7.99992 1.66658C8.88881 1.66658 9.71936 1.8277 10.4916 2.14992C11.2638 2.47214 11.936 2.91936 12.5083 3.49158C13.0805 4.06381 13.5277 4.73603 13.8499 5.50825C14.1721 6.28047 14.3333 7.11103 14.3333 7.99992C14.3333 8.8777 14.1721 9.7027 13.8499 10.4749C13.5277 11.2471 13.0805 11.9194 12.5083 12.4916C11.936 13.0638 11.2638 13.5138 10.4916 13.8416C9.71936 14.1694 8.88881 14.3333 7.99992 14.3333C7.12214 14.3333 6.29714 14.1694 5.52492 13.8416C4.7527 13.5138 4.08047 13.0638 3.50825 12.4916C2.93603 11.9194 2.48603 11.2499 2.15825 10.4833C1.83047 9.71659 1.66658 8.88881 1.66658 7.99992C1.66658 7.11103 1.83047 6.28047 2.15825 5.50825C2.48603 4.73603 2.93603 4.06381 3.50825 3.49158C4.08047 2.91936 4.74992 2.47214 5.51658 2.14992C6.28325 1.8277 7.11103 1.66658 7.99992 1.66658Z"
        fill={theme.colors.primary.main}
      />
    </svg>
  );
};
